<div class="cf financial-ticker-wrap">
  <div class="d-flex margin-bottom-50" style="margin-bottom:50px;" *ngIf="isFromDashboard">
    <a class="filter btn ml-auto  btn-circle btn-green adduserbtn" href="javascript:void(0);" placement="left" tooltip="Add Tickers" (click)="openAddTicker(AddTicker,'panlestyle')"><i class="fa fa-plus icon" aria-hidden="true"></i></a>
  </div>
  
  <ngx-slick-carousel class="carousel" *ngIf="stockInfo.length > 0 && showMarketValue"
                      #slickModal="slick-carousel" [config]="slideConfig"
                      (afterChange)="afterChange($event)">

    <div ngxSlickItem class="ticker-box d-flex" *ngFor="let item of stockInfo; let i=index" [ngClass]="symbol==item?.symbol && fromSummaryPage ? 'selectedTicker' : 'normalTicker'" [hidden]="item == null">
      <div class="lft mr-auto">
        <div class="ticker-brand">
          <a (click)="changeTicker(item?.symbol)" tooltip="{{item?.brand}}" placement="bottom"> {{item?.brand}}</a>

        </div>
        <div class="data-big">
          <span [style.color]="getColorForStock(item?.regularMarketChangePercent)">{{item?.regularMarketChangePercent}}</span>
          <span [style.color]="getColorForStock(item?.postMarketChangePercent)" class="data-small"> {{item?.postMarketChangePercent}}</span>
        </div>
      </div>
      <div class="rt">
        <div class="data-small">{{item?.currentPrice}} <span style="color:orange"> D</span></div>
        <div class="arrow top" *ngIf="stockValueHigh(item?.regularMarketChangePercent)"> &uarr;</div>
        <div class="arrow bottom" *ngIf="!stockValueHigh(item?.regularMarketChangePercent)"> &uarr;</div>
        <div id="{{item?.symbol}}" style="width: 70px; height: 50px; margin: 0 auto"></div>
      </div>

      <a class="remove" tooltip="Remove Ticker" placement="bottom" href="javascript:void(0);" (click)="openModalForDeleteTicker(RemoveTicker,'deletemodal',item.symbol)"><i aria-hidden="true" class="icofont icofont-close"></i></a>

    </div>
  </ngx-slick-carousel>
</div>

<ng-template #RemoveTicker>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Remove Ticker</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefRemoveTicker.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">
        <div class="form-group">
            <h6 class="displayvalue">Are you sure to remove this ticker for the seller ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRefRemoveTicker.hide()">Cancel</button>
            <button class="btn btn-lg btn-danger" (click)="removeTicker();modalRefRemoveTicker.hide();">Remove</button>
        </div>
    </div>
</ng-template>

<ng-template #AddTicker>
    <app-shared-ticker-add [userId]="sellerId" (closeModal)="closeAddTickerModal($event)" [modalRef]="modalRefAddTicker"></app-shared-ticker-add>
</ng-template>
